import { create, all } from 'mathjs'

// Central mathjs instance configured for high-precision arithmetic.
// BigNumber prevents floating-point drift in scaling computations.
export const math = create(all, {
  number: 'BigNumber',
  precision: 64,
} as any)

export type BigNumber = import('mathjs').BigNumber
export type MathInstance = typeof math

